import { useEffect } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import TopNavigation from "@/components/TopNavigation";
import { useAuth } from "@/contexts/AuthContext";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated) {
        navigate("/login");
      } else if (location.pathname === "/dashboard") {
        navigate("/dashboard/projects", { replace: true });
      }
    }
  }, [loading, isAuthenticated, location.pathname, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-muted-foreground">Loading ...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-muted">
      <div className="flex h-screen">
        <Sidebar />

        <div className="flex-1 flex flex-col lg:ml-0">
          <TopNavigation />

          <main id="body_main" className="flex-1 overflow-auto p-4 lg:p-6 border border-border rounded-lg m-2 lg:m-4 bg-card">
            <div className="max-w-7xl mx-auto">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
